import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Container, Col } from "react-bootstrap";
import "./CodeAudit.scss";
import ReactMarkdown from "react-markdown";
import Scrollbars from "react-custom-scrollbars-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faDownload, faCheck, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "../../common-components/button/Button.jsx";
import { setShowCodeAudit } from "../../state/reducers/codeAudit";

function CodeAuditResult() {
  const CodeAuditData = useSelector((state) => state.codeAudit?.codeAudit);
  const isLoading = useSelector((state) => state.codeAudit.loading);
  const [copied, setCopied] = useState(false);

  const dispatch = useDispatch();

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      
      // Reset the icon after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };

  const downloadResult = () => {
    const element = document.createElement("a");
    const file = new Blob([CodeAuditData], {type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = "CodeAuditData.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="page-wrapper code-overview-page">
      <Container fluid>
        <Row>
          <Col>
            {!isLoading && (
              <div className="content-wrap">
                <h2 className="page-title">Code Audit</h2>
                {CodeAuditData ? ( 
                  <div className="code-audit-wrapper">
                    <Row>
                      <Col>
                        <div className="code-audit-text-wrapper">
                          <button className="copy-btn" onClick={() => copyToClipboard(CodeAuditData)}>
                            <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="copy-icon"/> <span>Copy</span>
                          </button>
                          <Scrollbars>
                            <ReactMarkdown className="code-audit-text">
                              {CodeAuditData}
                            </ReactMarkdown>
                          </Scrollbars>
                        </div>
                        <div className="text-end">
                          <CustomButton label={<><FontAwesomeIcon icon={faAngleLeft} className="dld-icon" /> <span>Back</span></>} onClick={() => dispatch(setShowCodeAudit(false))} className="back-btn" />
                          <button className="download-btn" onClick={downloadResult}>
                            <FontAwesomeIcon icon={faDownload} className="dld-icon" /> <span>Download Code Audit</span>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ) : (
                  <div className="err-msg">Unable to process your request. Please verify all required information is provided correctly and try again.</div>
                )}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CodeAuditResult;